import { Midi } from '@tonejs/midi';
import { Chord, ChordProgression } from './types';

export function assertValidMidiProgression(midi: Midi) {
  const midiName = midi.name.replace(/[^a-z0-9_]/gi, '');
  if (midi.tracks.length !== 1) throw new Error(`Midi chord progression '${midiName}' must contain 1 track, found ${midi.tracks.length}.`);
  const track = midi.tracks[0];
  const positivityControl = track.controlChanges[102];
  const energyControl = track.controlChanges[103];
  if (!positivityControl) throw new Error(`Midi progression ${midiName} missing positivity value on control 102.`);
  if (positivityControl.length !== 1) {
    throw new Error(
      `Midi progression ${midiName} should have 1 control mapped to control 102. Found ${positivityControl.length} controls.`,
    );
  }
  if (!energyControl) throw new Error(`Midi progression ${midiName} missing energy value on control 103.`);
  if (energyControl.length !== 1) {
    throw new Error(
      `Midi progression ${midiName} should have 1 control mapped to control 103. Found ${positivityControl.length} controls.`,
    );
  }
}

export async function loadMidiChordProgression(url: string): Promise<ChordProgression> {
  const midi = await Midi.fromUrl(url);
  assertValidMidiProgression(midi);
  const chords: Chord[] = [];
  let previousNoteTick = -1;
  const track = midi.tracks[0];
  track.notes.forEach((note) => {
    if (note.ticks !== previousNoteTick) {
      previousNoteTick = note.ticks;
      chords.push({
        notes: [note.name],
        time: `${note.time}m`,
        duration: `${note.duration}m`,
        velocity: note.velocity,
      });
    } else {
      chords[chords.length - 1].notes.push(note.name);
    }
  });
  // Parsed midi name is suffixed with a 'NULL' (\u0000) character
  const midiName = midi.name.replace(/[^a-z0-9_]/gi, '');
  const positivityControl = track.controlChanges[102];
  const energyControl = track.controlChanges[103];
  return {
    name: midiName,
    chords,
    positivity: positivityControl[0].value,
    energy: energyControl[0].value,
  };
}
